<template>
  <header>
    <img class="logo" @click="skip('/')" src="@/assets/pcImg/logo.png" />
    <div class="page">
      <div @click="skip('/')" v-if="!this.loginInfo" class="navigation">
        Home
      </div>
      <div
        @click="skip('/questionnaire')"
        v-if="this.loginInfo"
        class="navigation"
      >
        Survey
      </div>
      <div
        @click="skip('/IntegralAward')"
        class="navigation"
        v-if="!this.loginInfo"
      >
        Rewards
      </div>

      <div @click="skip('/rewards')" class="navigation" v-if="this.loginInfo">
        Rewards
      </div>
      <div
        @click="skip('/aboutQuestionnaire')"
        v-if="!this.loginInfo"
        class="navigation"
      >
        About
      </div>
      <div @click="skip('/helpFeedback')" class="navigation">Help</div>
    </div>
    <div class="btn-img" v-if="!this.loginInfo">
      <button class="sign-up" @click="skip('/logon')">Sign up</button>
      <button class="log-in" @click="skip('/login')">Log in</button>
      <div @click="shade" class="question-mark">EN</div>
    </div>
    <div class="btn-img imgs" v-else>
      <img
        class="avatarUrl"
        :src="userInfo.avatarUrl"
        @click="userSetupShow = !userSetupShow"
      />
      <img
        class="Inverted-triangle"
        src="@/assets/pcImg/Inverted-triangle.png"
        @click="userSetupShow = !userSetupShow"
      />
      <div class="user-setup" v-if="userSetupShow">
        <div @click="skip('/settingsProfile')">Account Settings</div>
        <div @click="skip('/redemptionRecords')">Redemption records</div>
      </div>
    </div>
    <div class="herder-right">
      <img src="@/assets/pcImg/herder-right.png" @click="changebox" />
      <div class="box-home" v-if="show">
        <div class="en" @click="shade"><span>EN</span></div>
        <div @click="skip('/')">Home</div>
        <div @click="skip('/IntegralAward')">Rewards</div>
        <div @click="skip('/helpFeedback')">About</div>
        <div @click="skip('/logon')">Sign up</div>
        <div @click="skip('/login')">Log in</div>
      </div>
    </div>
    <div class="mask" v-if="maskShow"></div>
    <div class="language" v-if="maskShow">
      <img
        class="close-x"
        src="@/assets/pcImg/close-x.png"
        @click="maskShow = false"
      />
      <div class="title">Choose your language</div>
      <div>
        <div
          class="language-now"
          @click="changeLanguage(item)"
          v-for="item in list"
          :key="item.language"
        >
          <div>{{ item.name }}</div>
          <img
            v-if="active === item.language"
            class="selected"
            src="@/assets/pcImg/selected.png"
          />
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { accounts } from "@/api/api.js";
export default {
  data() {
    return {
      show: false,
      maskShow: false,
      active: "USA",
      list: [
        {
          language: "USA",
          name: "English",
          url: "https://www.weopinions.com/?lang=hk",
        },
        {
          language: "JP",
          name: "Japanese",
          url: "https://jp.weopinions.com/",
        },
        {
          language: "Korean",
          name: "한국",
          url: "https://kr.weopinions.com/",
        },
        {
          language: "Vietnamese",
          name: "Việt Nam",
          url: "https://vn.weopinions.com/",
        },
        {
          language: "th",
          name: "ประเทศไทย",
          url: "https://th.weopinions.com/",
        },
        {
          language: "Indonesian",
          name: "Indonesia",
          url: "https://id.weopinions.com/",
        },
        {
          language: "Malay",
          name: "Malaysia",
          url: "https://mas.weopinions.com/",
        },
        {
          language: "tw",
          name: "中國臺灣",
          url: "https://tw.weopinions.com/",
        },
        {
          language: "hk",
          name: "中国香港",
          url: "https://hk.weopinions.com/",
        },
        {
          language: "sg",
          name: "Singapore",
          url: "https://sg.weopinions.com/",
        },
        {
          language: "au",
          name: "Australia",
          url: "https://au.weopinions.com/",
        },
        {
          language: "ph",
          name: "Filipino",
          url: "https://ph.weopinions.com/",
        },
        {
          language: "in",
          name: "भारत",
          url: "https://in.weopinions.com/",
        },
        {
          language: "nz",
          name: "New Zealand",
          url: "https://nz.weopinions.com/",
        },
        {
          language: "la",
          name: "ລາວ",
          url: "https://la.weopinions.com/",
        },
        {
          language: "kh",
          name: "កម្្ពុជា",
          url: "https://kh.weopinions.com/",
        },
      ],
      loginInfo: null, //登录信息
      userInfo: null,
      path: null,
      userSetupShow: false,
    };
  },
  methods: {
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
    changebox() {
      this.show = !this.show;
    },
    shade() {
      this.maskShow = !this.maskShow;
    },
    //获取用户信息
    async initPage() {
      //用户信息
      this.userInfo = JSON.parse(localStorage.getItem("accountInfo"));
      if (this.userInfo) return;
      const params = {
        id: this.loginInfo.id,
      };
      await accounts(params).then((res) => {
        if (res.code === 200) {
          this.$store.commit("setAccountInfo", res.data);
          this.userInfo = res.data;
          console.log("获取用户信息", this.userInfo);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    changeLanguage(data) {
      if (data.language === this.active) {
        return;
      }
      location.href = data.url;
      this.maskShow = false;
    },
  },
  created() {
    this.loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));

    if (!this.loginInfo) return;
    this.initPage();
    console.log("头部重新渲染", this.loginInfo);
  },
  mounted() {
    // 获得路由
    switch (this.$route.path) {
      case "/questionnaire":
        document.getElementsByClassName("navigation")[0].style.color =
          "#2E67EA";
        break;
      case "/":
        if (!this.loginInfo)
          document.getElementsByClassName("navigation")[0].style.color =
            "#2E67EA";
        break;
      case "/IntegralAward":
        document.getElementsByClassName("navigation")[1].style.color =
          "#2E67EA";
        break;
      case "/aboutQuestionnaire":
        if (!this.loginInfo)
          document.getElementsByClassName("navigation")[2].style.color =
            "#2E67EA";
        break;
      case "/helpFeedback":
        if (!this.loginInfo) {
          document.getElementsByClassName("navigation")[3].style.color =
            "#2E67EA";
          break;
        } else {
          document.getElementsByClassName("navigation")[2].style.color =
            "#2E67EA";
        }
      default:
        console.log(this.$route.path.indexOf("/rewards"));
        if (this.$route.path.indexOf("/rewards") !== -1) {
          document.getElementsByClassName("navigation")[1].style.color =
            "#2E67EA";
        }
        break;
    }
  },
};
</script>
<style scoped>
header {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 10px;
  font-weight: bold;
  color: #232323;
  background-color: #fff;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.logo {
  width: 105.625px;
  height: 21.25px;
  margin-left: 87.5px;
  cursor: pointer;
}
.page {
  display: flex;
  justify-content: space-around;
  width: calc(100% - 450.625px);
}
.page > div {
  cursor: pointer;
}
.btn-img {
  display: flex;
}
.imgs {
  align-items: center;
  position: relative;
}
.avatarUrl {
  width: 22.5px;
  height: 22.5px;
  border-radius: 22.5px;
  background-color: #cccccc;
  cursor: pointer;
}

.Inverted-triangle {
  margin-right: 87.5px;
  width: 15px;
  margin-left: 4px;
  cursor: pointer;
}
.user-setup {
  position: absolute;
  top: 36px;
  left: -50px;
  background: #fff;
  background: #ffffff;
  box-shadow: 0px 5.625px 17.5px 0.625px rgba(0, 0, 0, 0.05);
  border-radius: 1.25px;
}
.user-setup > div {
  font-size: 7.5px;
  font-weight: 400;
  color: #232323;
  height: 18px;
  line-height: 18px;
  cursor: pointer;
  padding: 0 10px;
}
.user-setup > div:hover {
  background-color: #f5f5f5;
}
.herder-right {
  display: none;
}
.question-mark {
  width: 22.5px;
  height: 22.5px;
  border-radius: 22.5px;
  border: 0.625px solid #2e67ea;
  margin-right: 87.5px;
  text-align: center;
  line-height: 22.5px;
  cursor: pointer;
}
.box-home {
  background-color: #fff;
}
.sign-up {
  width: 56.25px;
  height: 22.5px;
  padding: 0;
  border-radius: 22.5px;
  line-height: 22.5px;
  background: #2e67ea;
  font-size: 8.75px;
  color: #fff;
  cursor: pointer;
  margin-right: 17.4px;
}
.log-in {
  width: 56.25px;
  height: 22.5px;
  border-radius: 22.5px;
  line-height: 22.5px;
  padding: 0;
  background: #fff;
  border: 1px solid #2e67ea;
  font-size: 8.75px;
  cursor: pointer;
  margin-right: 17.4px;
}
.mask {
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
}

.language {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  max-width: 300px;
  height: 90vh;
  background-color: #fff;
  z-index: 9999999;
  overflow: auto;
  border-radius: 4px;
}
.close-x {
  float: right;
  margin-top: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.language .title {
  margin-top: 60px;
  text-align: center;
  font-size: 16px;
  margin-bottom: 20px;
}
.language .language-now {
  width: calc(100% - 40px);
  margin-left: 20px;
  height: 40px;
  line-height: 40px;
  border-bottom: 0.625px solid #e4e5e9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
}
.language-now .selected {
  width: 25px;
  height: 25px;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1140px) {
  .logo {
    margin-left: 20px;
  }
  .question-mark {
    margin-right: 20px;
  }
  .page {
    justify-content: space-around;
    width: calc(100% - 315.625px);
  }
}
@media only screen and (max-width: 768px) {
  .page {
    display: none;
  }
  .btn-img {
    display: none;
  }
  .herder-right {
    display: block;
    float: right;
    position: relative;
  }

  .herder-right > img {
    width: 25px;
    height: 25px;
    margin-right: 15px;
    cursor: pointer;
  }
  .herder-right .box-home {
    display: flex;
    flex-direction: column;
    width: 50vw;
    min-height: 50vh;
  }
  .logo {
    margin-left: calc(50% - 52.8125px);
  }
  .box-home {
    position: absolute;
    top: 32px;
    right: 0;
    width: 50px;
    font-size: 12px;
    font-weight: 500;
  }
  .box-home > div {
    margin-top: 15px;
    width: calc(100% - 40px);
    cursor: pointer;
    text-align: left;
    padding-left: 20px;
    padding-right: 40px;
    height: 25px;
    line-height: 25px;
  }
  .box-home > div:last-child {
    margin-bottom: 20px;
  }
  .box-home .en {
    text-align: right;
    font-weight: bold;
  }
  .box-home .en > span {
    display: inline-block;
    height: 25px;
    width: 25px;
    background-color: #e5e8ec;
    border-radius: 25px;
    text-align: center;
    line-height: 25px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/header.vue